(ns frontend.sub.view
  (:require
   [re-frame.core :as rf]
   [frontend.sub.entity :as entity-sub]))

(rf/reg-sub
 ::selected-view
 (fn [db]
   (::selected-view db)))

(rf/reg-sub
 ::selected-view-filter-model
 (fn [db]
   (let [selected-view (::selected-view db)
         ; Todo change data schema so filter model affects both list and card view!
         filter-model (get-in selected-view [:view/configuration :list-view :filter-model])]
     filter-model)))

(rf/reg-sub
 ::selected-view-id
 (fn [db _]
   (get-in db [::selected-view :db/id])))

(rf/reg-sub
 ::selected-view-modified?
 (fn [db _]
   (let [selected-view (::selected-view db)
         view-id (:db/id selected-view)
         original-view (get-in db [:entities view-id])
         modified? (not= selected-view original-view)]
     modified?)))

(rf/reg-sub
 ::views
 :<-
 [::entity-sub/entities-by-type]
 (fn [entities-by-type [_ {:keys [include-disabled?]}]]
   (cond->> entities-by-type
            true
            :entity.type/view
            (not include-disabled?)
            (remove (fn [view-entity]
                      (:common/disabled? view-entity)))
            true
            (vec))))

(rf/reg-sub
 ::changes-to-entities
 (fn [db [_ entity-type]]
   (get-in db [::changes-to-entities entity-type])))
